<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        @action="editFeedBack"
        v-model="dialog"
        :cons="{ title: $t('edit_feedback') }"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-edit-feedback-dialog`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('edit_feedback')"
          />
        </template>
        <v-card class="px-4 pb-4" flat>
          <v-card-title>{{ $t("select_type_replay") }}</v-card-title>

          <v-row no-gutters>
            <v-col class="pa-2" cols="12" md="4" sm="6">
              <div
                :class="computedValue.type === 'emoji' ? 'border-success' : ''"
                class="border border-2 rounded p-3 d-flex clickable"
                @click="selectType('emoji')"
              >
                <h1 class="my-auto mx-auto">😢</h1>

                <h1 class="my-auto mx-auto">😐</h1>

                <h1 class="my-auto mx-auto">🙂</h1>
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="4" sm="6">
              <div
                :class="computedValue.type === 'text' ? 'border-success' : ''"
                class="border border-2 rounded py-4 p-3 d-flex"
                @click="selectType('text')"
              >
                <p class="my-auto mx-auto">{{ $t("excellent") }}</p>

                <p class="my-auto mx-auto">{{ $t("good") }}</p>

                <p class="my-auto mx-auto">{{ $t("very_poor") }}</p>
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="4" sm="6">
              <div
                :class="
                  computedValue.type === 'emoji_slider' ? 'border-success' : ''
                "
                class="border border-2 rounded p-3"
                @click="selectType('emoji_slider')"
              >
                <v-slider :thumb-size="0" hide-details thumb-label="always">
                  <template v-slot:thumb-label="{ value }">
                    <h1>
                      {{
                        satisfactionEmojis[Math.min(Math.floor(value / 10), 9)]
                      }}
                    </h1>
                  </template>
                </v-slider>
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="4" sm="6">
              <div
                :class="computedValue.type === 'star' ? 'border-success' : ''"
                class="border border-2 rounded p-3 d-flex"
                @click="selectType('star')"
              >
                <h1 class="my-auto mx-auto">⭐</h1>

                <h1 class="my-auto mx-auto">⭐</h1>

                <h1 class="my-auto mx-auto">⭐</h1>
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="4" sm="6">
              <div
                :class="computedValue.type === 'thumbs' ? 'border-success' : ''"
                class="border border-2 rounded p-3 d-flex"
                @click="selectType('thumbs')"
              >
                <h1 class="my-auto mx-auto">👍</h1>

                <h1 class="my-auto mx-auto">👊</h1>

                <h1 class="my-auto mx-auto">👎</h1>
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="4" sm="6">
              <div
                :class="computedValue.type === 'slider' ? 'border-success' : ''"
                class="border border-2 rounded p-3"
                @click="selectType('slider')"
              >
                <v-slider :thumb-size="20" hide-details thumb-label="always" />
              </div>
            </v-col>
          </v-row>

          <v-divider />

          <v-card-actions>
            <div class="rowinfo" style="width: 100% !important">
              <v-text-field
                v-model="computedValue.question"
                :rules="rules"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contnetinfo"
                counter="50"
                dense
                label="سوال"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-question`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('question')"
              />
            </div>
          </v-card-actions>

          <v-card-text class="pt-0">
            <span>{{ $t("field_discription") }}</span>
            <v-card-actions class="mb-2 flex-column align-start">
              <v-switch
                v-model="computedValue.description"
                class="ma-0"
                dense
                :label="$t('description')"
                :messages="$t('messages_discription')"
              />

              <v-radio-group
                v-show="computedValue.description"
                v-model="computedValue.forceDesc"
                mandatory
                row
              >
                <v-radio :value="false" :label="$t('optional')" />
                <v-radio :value="true" :label="$t('required')" />
              </v-radio-group>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "feedbackQuestionPicker",

  props: {
    value: Boolean,
    item: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "feedbackQuestionPicker",

      satisfactionEmojis: [
        "😭",
        "😢",
        "☹️",
        "🙁",
        "😐",
        "🙂",
        "😊",
        "😁",
        "😄",
        "😍",
      ],
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    rules() {
      return [
        (v) => (v.length >= 3 && v.length <= 50) || this.$t("number_char"),
      ];
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedValue: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update:item", val);
      },
    },
  },

  methods: {
    selectType(type) {
      this.computedValue.type = type;
      this.$forceUpdate();
    },
    editFeedBack(e) {
      if (e == "submit") {
        this.$emit("editFeedBack", this.computedValue);
      }
    },
  },
};
</script>

<style scoped></style>
